import "./emptyData.scss";

// images
import {images} from "../../../constants/images";

const EmptyData = () => {
  return (
    <div className="emptyDataContainer">
        <img src={images.empty_data} alt="Empty data" />
        <span>Empty Data</span>
    </div>
  )
}

export default EmptyData